import { LOGOUT_SUCCESS } from './types';
import localForage from 'localforage';
import sendData from './sendData';

export default function () {
  return async (dispatch, getState) => {
    await Promise.all([sendUserLogout().catch((e) => e), localStorage.clear(), localForage.clear()]).catch((e) => e);

    dispatch({ type: LOGOUT_SUCCESS });

    window.location.href = window.location.origin;
  };
}

export const sendUserToLogout = () => {
  return (window.location.href = `${window.location.origin}/logout`);
};

export const sendUserLogout = async () => {
  await sendData({ url: '/user/logout', method: 'delete' }, { useNamespace: false });
};
